import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Grid, Menu } from 'semantic-ui-react';
import { sortBy } from 'lodash';
import SetBonusTable from '../../items/detail/summary-card/itemsets/SetBonusTable';
import SimpleItemCard from '../../common/items/SimpleItemCard';

export default class SynergyCrystalBonusView extends Component {

    constructor() {
        super();

        this.state = {
            sortedCrystals: [],
            crystal: null,
            currentIndex: 0,
        };
    }

    componentDidMount() {
        const {crystals} = this.props;

        const sortedCrystals = sortBy(crystals, c => c.Name.English);

        this.setState({
            sortedCrystals: sortedCrystals,
            crystal: sortedCrystals[0],
        });
    }

    onMenuClick = (e, data) => {

        const {sortedCrystals, currentIndex} = this.state;
        let nextIndex = currentIndex;

        if(data.direction === 'forward') {
            nextIndex = (currentIndex === sortedCrystals.length - 1) ? 0 : currentIndex + 1;
        } else if(data.direction === 'back') {
            nextIndex = (currentIndex === 0) ? sortedCrystals.length - 1 : currentIndex - 1;
        }

        this.setState({
            crystal: sortedCrystals[nextIndex],
            currentIndex: nextIndex,
        });
    }

    render() {

        const {sortedCrystals, crystal} = this.state;

        if(!sortedCrystals || sortedCrystals.length === 0) {
            return null;
        }

        return (
            <Grid>
                <Grid.Row centered>
                    <Grid.Column>
                        <Menu compact>
                            <Menu.Item icon="step backward" direction='back' onClick={this.onMenuClick}></Menu.Item>
                            <Menu.Item>
                                <SimpleItemCard image={crystal.Icon} name={crystal.Name} rarity={crystal.Rarity} category={crystal.Category} itemKey={crystal.ItemKey} size='mini'/>
                            </Menu.Item>
                            <Menu.Item icon="step forward" direction='forward' onClick={this.onMenuClick}></Menu.Item>
                        </Menu>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column>
                        <SetBonusTable bonuses={crystal.Equipment.ItemSet.Bonuses} />
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        );
    }
}

SynergyCrystalBonusView.propTypes = {
    crystals: PropTypes.array.isRequired,
};


// WEBPACK FOOTER //
// ./src/itemsets/components/SynergyCrystalBonusView.jsx